var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 94.6875H25.3125V30H34.6875V40.6397C35.6181 40.7471 36.6638 40.8897 37.8019 41.0794C42.3276 41.8337 48.4336 43.351 54.5963 46.4324C60.7774 49.5229 67.1011 54.2323 71.869 61.3842C76.0178 67.6074 78.8475 75.4701 79.5287 85.3125H90V94.6875ZM70.1276 85.3125C69.4744 77.2683 67.1471 71.2024 64.0685 66.5845C60.3989 61.0802 55.4726 57.3521 50.4037 54.8176C45.3164 52.274 40.1724 50.9788 36.2606 50.3268C35.7079 50.2347 35.1823 50.1559 34.6875 50.0883V85.3125H70.1276Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.cd5362c392bdfc41e387f182b28d82c8.svg";
export { ForwardRef as ReactComponent };